import { TFunction } from "i18next";
import { ITemplate } from '../../templateModel'
import { IAction } from "../NewMessage/LinkSet/linkSet";

export const getInitAdaptiveCard = (t: TFunction) => {

    return (
        {
            "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
            "type": "AdaptiveCard",
            "version": "1.2",
            "backgroundImage": {
                "url": "/Content/colors/E3F3F7.png"
            },
            "body": [
                {
                    "type": "Container",
                    "spacing": "Default",
                    "items": [
                        {
                            "type": "Image",
                            "spacing": "none",
                            "url": "https://placehold.co/507x76/000000/png",
                            "size": "Stretch",
                            "width": "400px",
                            "altText": ""
                        }
                    ]
                } as any,
                {
                    "type": "Container",
                    "spacing": "Default",
                    "items": []
                }

            ]
        }
    )
}

export const setTemplateBanner = (card: any, bannerUrl: string) => {
    card.body[0].items[0].url = bannerUrl;
}

export const setTemplateColor = (card: any, colorUrl: string) => {
    card.backgroundImage.url = colorUrl;
}

export const setTemplateTextColor = (card: any, textColor: string) => {
    card.body[1].items.forEach((item: any) => {
        if (item.type === "TextBlock") {
            item.color = textColor;
        }
    })
}

export const setTemplateElements = (t: TFunction, card: any, elements: string[], textColor: string) => {
    card.body[1].items = []
    elements.forEach(e => {
        if (e.startsWith("Title")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "weight": "Bolder",
                "text": t("TitleText"),
                "size": "ExtraLarge",
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("Image")) {
            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": "/image/imagePlaceholder.png",
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("VideoLink")) {
            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": "/Content/Video_Thumbnail.png",
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("Summary") || e.includes("Secondary summary")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "text": "Summary",
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("Author")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "wrap": true,
                "size": "Default",
                "weight": "Default",
                "text": "Author",
                "color": textColor
            })
        } else if (e.startsWith("Actions")) {
            card.body[1].items.push({
                "type": "ActionSet",
                "actions": [
                    {
                        "type": "Action.OpenUrl",
                        "title": "Button",
                        "url": "https://adaptivecards.io"
                    },
                    {
                        "type": "Action.OpenUrl",
                        "title": "Button",
                        "url": "https://adaptivecards.io"
                    }
                ]
            })
        }
    })
}

export const setCardStyle = (t: TFunction, cardTemplate: any, template: ITemplate, elements?: string[]) => {
    //raname to default
    var card = getInitAdaptiveCard(t);
    var textColor = "dark";
    if (template) {
        card.body[0].items[0].url = template.bannerUrl;
        card.backgroundImage.url = template.backgroundColorUrl;
        textColor = template.textColor;
    } else {
        card.body[0].items[0].url = "https://placehold.co/507x76/000000/png";
        card.backgroundImage.url = "/Content/colors/FFFFFF.png";
    }

    var cardElements = elements ? elements : template.elements

    card.body[1].items = []
    cardElements.forEach(e => {
        if (e.startsWith("Title")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "weight": "Bolder",
                "text": t("TitleText"),
                "size": "ExtraLarge",
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("Image")) {
            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": "/image/imagePlaceholder.png",
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("Video")) {
            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": "/Content/Video_Thumbnail.png",
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("Summary")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "text": t("Summary"),
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("SecondarySummary")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "text": t("Summary"),
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("Author")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "wrap": true,
                "size": "Default",
                "weight": "Default",
                "text": t("Author"),
                "color": textColor
            })
        } else if (e.startsWith("Actions")) {
            card.body[1].items.push({
                "type": "ActionSet",
                "actions": [
                    {
                        "type": "Action.OpenUrl",
                        "title": "Button",
                        "url": "https://adaptivecards.io"
                    },
                    {
                        "type": "Action.OpenUrl",
                        "title": "Button",
                        "url": "https://adaptivecards.io"
                    }
                ]
            })
        }
    })
}

export const getCardTitle = (card: any, elements: string[]) => {
    var elementIndex = elements.indexOf("Title");
    if (elementIndex > -1) {
        return card.body[1].items[elementIndex].text;
    }
}



export const setCard = (t: TFunction, card: any, elements: string[], textColor: string, state?: any, template?: ITemplate) => {

    if (template) {
        card.body[0].items[0].url = template.bannerUrl;
        card.backgroundImage.url = template.backgroundColorUrl;
        textColor = template.textColor;
    } else {
        card.body[0].items[0].url = "https://placehold.co/507x76/000000/png";
        card.backgroundImage.url = "/Content/colors/FFFFFF.png";
    }

    card.body[1].items = []
    elements.forEach(e => {
        if (e.startsWith("Title")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "weight": "Bolder",
                "text": state.titles && state.titles[e] || "",
                "size": "ExtraLarge",
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("ImageLink")) {
            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": state.imageLinks && state.imageLinks[e] || "",
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("VideoLink")) {
            var url = "";

            if (state.videoLinks && state.videoLinks[e] && state.videoLinks[e].url) {
                url = state.videoLinks[e].previewUrl || "/Content/Video_Thumbnail.png";
            }

            card.body[1].items.push({
                "type": "Image",
                "spacing": "Default",
                "url": url,
                "size": "Stretch",
                "width": "400px",
                "altText": ""
            })
        } else if (e.startsWith("Summary")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "text": state.summaries && state.summaries[e] || "",
                "wrap": true,
                "color": textColor
            })
        }
        else if (e.includes("SecondarySummary")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "text": state.secondarySummaries && state.secondarySummaries[e] || "",
                "wrap": true,
                "color": textColor
            })
        } else if (e.startsWith("Author")) {
            card.body[1].items.push({
                "type": "TextBlock",
                "wrap": true,
                "size": "Default",
                "weight": "Default",
                "text": state.authors && state.authors[e] || "",
                "color": textColor
            })
        } else if (e.startsWith("Actions")) {
            var actions = [];

            if (state.actionsBlocks && state.actionsBlocks[e]) {
                actions = state.actionsBlocks[e].map((action: IAction) => ({
                    "type": "Action.OpenUrl",
                    "title": action.title,
                    "url": action.link
                }))
            }

            card.body[1].items.push({
                "type": "ActionSet",
                "actions": actions
            })
        }
    })
}




export const getCardImageLink = (card: any, elements: string[]) => {
    var elementIndex = elements.indexOf("Image");
    if (elementIndex > -1) {
        return card.body[1].items[elementIndex].url;
    }
}


export const getCardVideoLink = (card: any, elements: string[]) => {
    var elementIndex = elements.indexOf("Video");
    if (elementIndex > -1) {
        return card.body[1].items[elementIndex].url;
    }
}

export const setCardVideoLink = (card: any, elements: string[], videoLink?: string, videoImageLink?: string) => {
    var elementIndex = elements.indexOf("Video");
    if (elementIndex > -1) {
        if (videoLink) {
            card.body[1].items[elementIndex].url = videoImageLink || "/Content/Video_Thumbnail.png"
        } else {
            card.body[1].items[elementIndex].url = ""
        }

    }
}

export const getCardSummary = (card: any, elements: string[]) => {
    var elementIndex = elements.indexOf("Summary");
    if (elementIndex > -1) {
        return card.body[1].items[elementIndex].text;
    }
}


export const getCardAuthor = (card: any, elements: string[]) => {
    var elementIndex = elements.indexOf("Author");
    if (elementIndex > -1) {
        return card.body[1].items[elementIndex].text;
    }
}

export const setCardAuthor = (card: any, elements: string[], author?: string) => {
    var elementIndex = elements.indexOf("Author");
    if (elementIndex > -1) {
        card.body[1].items[elementIndex].text = author;
    }
}

export const getCardBtnTitle = (card: any) => {
    return card.actions[1].title;
}

export const getCardBtnLink = (card: any) => {
    return card.actions[1].url;
}

export const setActions = (card: any, elements: string[], actions: any[]) => {
    var elementIndex = elements.indexOf("Actions");
    if (elementIndex > -1) {
        let urlsAndEvents: any[] = actions ? [...actions] : []
        if (urlsAndEvents.length !== 0) {

            card.body[1].items[elementIndex].actions = []
            urlsAndEvents.forEach(x => card.body[1].items[elementIndex].actions.push({
                "type": "Action.OpenUrl",
                "title": x.title === "" ? "Button" : x.title,
                "url": x.link
            }))
        } else {
            card.body[1].items[elementIndex].actions = [];
        }
    }
}

export const enableMultiSpaces = (str: string): string => {
    const regexp: RegExp = / (?= )/g;
    // zero width non-joiner
    return str?.replaceAll(regexp, ` ${String.fromCharCode(8204)}`)
}